import { Dialog } from '@spritz-finance/ui'
import React, { useContext, useState } from 'react'
import { FEEDBACK_OPENED } from '../analytics/events'
import { GenericFeedbackForm } from '../components/Feedback/FeedbackForm'
import { useAnalytics } from './useAnalytics'

export enum FeedbackForm {
    GenericFeedback = 'GenericFeedback',
    RequestMerchant = 'RequestMerchant',
    Wallet = 'Wallet',
    EmailNotHelpful = 'EmailNotHelpful',
    NoPayment = 'NoPayment',
}

type IFeedbackContext =
    | {
          openFeedbackForm: (form?: FeedbackForm, label?: string) => void
      }
    | undefined

const FeedbackState = React.createContext<IFeedbackContext>(undefined)

export const useFeedback = () => {
    const context = useContext(FeedbackState)
    if (!context) throw new Error('Cannot use useFeedback outside of a <FeedbackProvider />')
    return context
}

type Form = {
    type: FeedbackForm
    label?: string
}

export const FeedbackProvider: React.FC = ({ children }) => {
    const { trackAnalyticsEvent } = useAnalytics()
    const [form, setForm] = useState<Form | null>(null)

    const openFeedbackForm = (type = FeedbackForm.GenericFeedback, label?: string) => {
        trackAnalyticsEvent(FEEDBACK_OPENED, { formId: type })
        setForm({
            type,
            label,
        })
    }

    const handleClose = () => {
        setForm(null)
    }

    return (
        <FeedbackState.Provider value={{ openFeedbackForm }}>
            {children}
            <Dialog open={!!form} onClose={handleClose}>
                <Dialog.Content
                    minWidth={560}
                    style={{ minHeight: 200, padding: 40, maxWidth: 600 }}
                >
                    {form && <GenericFeedbackForm formId={form.type} label={form.label} />}
                </Dialog.Content>
            </Dialog>
        </FeedbackState.Provider>
    )
}
